<div class="flex justify-between mt-4 font-light text-xs pr-6 font-italic">
  <span class="flex-1">{{ 'Missing skills' | translate }}</span>
  <div class="flex-1">
    <span *ngFor="let skill of skills; let isLast = last; trackBy: trackById">
      {{ skill }}<ng-container *ngIf="!isLast">,</ng-container>
    </span>
  </div>
</div>
